// extracted by mini-css-extract-plugin
export default {"message":"_1LoBc4iMe7gaUMnCNpvq7k"};